import { PaginationParams, SearchingProps } from 'modules/Shared/type';
import SensorSoftware from 'modules/Sensor/model/SensorSoftware';

export interface HubSoftwareListState extends SearchingProps {
  hubSoftwares: SensorSoftware[];
  fetching: boolean;
  totalPages: number;
  pagination: PaginationParams;
}

export const initHubSoftwareListState = (): HubSoftwareListState => ({
  hubSoftwares: [],
  pagination: {
    page: 1,
    count: 100
  },
  totalPages: 1,
  filter: {},
  sort: {},
  fetching: false
});
